module.exports = __webpack_public_path__ + "img/00004.e2bd343f.webp";